import React, { useState } from 'react';
import { IconButton, RegularButton, Skeleton, type RegularButtonSize } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { ShoppingCartIcon } from '@fronton/icons-react';
import { css, cx } from 'linaria';

export const ADD_TO_CART_BTN_QA = 'product-cart-button';

export const ProductCartButton: React.FC<{
  className?: string;
  isActive: boolean;
  isLoading: boolean;
  isBot: boolean;
  size?: RegularButtonSize;
  wide?: boolean;
  iconButtonOnMobile?: boolean;
  onClick: () => void;
}> = ({ className, size = 'm', wide, isActive, isLoading, isBot, onClick, iconButtonOnMobile }) => {
  const { t } = useTranslation();
  const [hoveredOnce, setHoveredOnce] = useState(false);

  const onMouseLeave = () => {
    if (isActive && !hoveredOnce) setHoveredOnce(true);
  };

  const commonProps = {
    'data-qa': ADD_TO_CART_BTN_QA,
    onClick,
    onMouseLeave,
    'aria-label': t('ui.aria-label.add-to-cart'),
    variant: 'primary' as const,
  };

  const content = (
    <>
      <RegularButton
        {...commonProps}
        className={cx(className, iconButtonOnMobile ? desktopButtonStyle : mobileButtonStyle)}
        size={size}
        wide={wide}
      >
        {t('ui.button.add-to-cart')}
      </RegularButton>

      {iconButtonOnMobile && (
        <IconButton {...commonProps} className={cx(className, mobileIconStyle)} invert size="l">
          <ShoppingCartIcon type="outline" size="l" color="text-primary" />
        </IconButton>
      )}
    </>
  );

  return isLoading && !isBot ? (
    <Skeleton width="100%" variant="control">
      {content}
    </Skeleton>
  ) : (
    content
  );
};

const mobileIconStyle = css`
  display: none;

  @media (width <= 400px) {
    display: block;
  }
`;

const mobileButtonStyle = css`
  @media (--to-desktop) {
    width: 100%;
  }
`;

const desktopButtonStyle = css`
  display: block;

  @media (width <= 400px) {
    display: none;
  }
`;
